/*
  Debug: Hero / Nav overlap
  Loaded only by sections that opt in (see collection-hero-seo.liquid), and only
  does anything when the current URL has &debug=1. Shows the real, live numbers
  behind the hero/nav overlap bug: the theme's --nav-height custom property,
  the header's actual rendered height, the hero section's computed padding-top,
  and the exact pixel overlap (if any) between the header and the hero's H1.

  Shipped as an external asset file (rather than an inline <script>) so it runs
  even on storefronts with a strict Content-Security-Policy that blocks
  un-nonced inline scripts — Shopify's own asset CDN is allowlisted by default.
*/
(function () {
  if (window.location.search.indexOf('debug=1') === -1) return;

  function runHeroDebug() {
    var section = document.querySelector('.collection-hero-seo');
    if (!section) return;

    var header = document.getElementById('site-control');
    var h1 = section.querySelector('.collection-hero-seo__title');
    var rootStyles = getComputedStyle(document.documentElement);
    var sectionStyles = getComputedStyle(section);

    var navHeightVar = rootStyles.getPropertyValue('--nav-height').trim();
    var headerRect = header ? header.getBoundingClientRect() : null;
    var h1Rect = h1 ? h1.getBoundingClientRect() : null;

    var overlapPx = (headerRect && h1Rect) ? Math.max(0, headerRect.bottom - h1Rect.top) : null;

    var panel = document.createElement('div');
    panel.id = 'salt-hero-nav-debug-panel';
    panel.style.cssText = [
      'position:fixed', 'top:12px', 'right:12px', 'z-index:2147483647',
      'background:#112446', 'color:#fff', 'font:12px/1.5 monospace',
      'padding:14px 16px', 'border-radius:6px', 'max-width:340px',
      'box-shadow:0 4px 18px rgba(0,0,0,.35)'
    ].join(';');

    var lines = [
      '<strong>Hero/Nav debug (external asset)</strong>',
      '--nav-height (CSS var): ' + (navHeightVar || '(not set)'),
      'header (#site-control) found: ' + (header ? 'yes' : 'NO — selector did not match'),
      'header actual height: ' + (headerRect ? Math.round(headerRect.height) + 'px' : 'n/a'),
      'header bottom edge (viewport y): ' + (headerRect ? Math.round(headerRect.bottom) + 'px' : 'n/a'),
      'hero section padding-top (computed): ' + sectionStyles.paddingTop,
      'H1 found: ' + (h1 ? 'yes' : 'NO — selector did not match'),
      'H1 top edge (viewport y): ' + (h1Rect ? Math.round(h1Rect.top) + 'px' : 'n/a'),
      overlapPx === null ? 'overlap: n/a' :
        (overlapPx > 0
          ? '<span style="color:#ff8a80">OVERLAP: ' + Math.round(overlapPx) + 'px — H1 top is under the header</span>'
          : '<span style="color:#8affab">no overlap</span>')
    ];

    panel.innerHTML = lines.join('<br>');

    section.style.outline = '2px dashed #ff8a80';
    if (header) header.style.outline = '2px dashed #7fc8ff';

    document.body.appendChild(panel);
  }

  if (document.readyState === 'complete') {
    runHeroDebug();
  } else {
    window.addEventListener('load', runHeroDebug);
  }
})();